var _circle, _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEMail = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FFBB00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5L12.525 5.2C12.675 5.29167 12.7917 5.41667 12.875 5.575C12.9583 5.73333 13 5.9 13 6.075V11.5C13 11.775 12.9021 12.0104 12.7063 12.2063C12.5104 12.4021 12.275 12.5 12 12.5H4C3.725 12.5 3.48958 12.4021 3.29375 12.2063C3.09792 12.0104 3 11.775 3 11.5V6.075C3 5.9 3.04167 5.73333 3.125 5.575C3.20833 5.41667 3.325 5.29167 3.475 5.2L8 2.5ZM8 8.325L11.9 6L8 3.675L4.1 6L8 8.325ZM8 9.5L4 7.1V11.5H12V7.1L8 9.5Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/e-mail.7b87b47b.svg";
export { ForwardRef as ReactComponent };